import { useMemo, useContext } from 'react';
import { getCurrentStepId, useWizardService } from '@bingads-webui-react/wizard-core';
import { CONFIRM_MESSAGES } from '@bingads-webui-campaign-react/campaign-settings-utils';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';

export const getStyles = () => ({
  confirmDialogContent: {
    '& .ms-Dialog-main': {
      width: '600px',
      maxWidth: '80%',
    },
    '& .ms-Dialog-subText': {
      display: 'none',
    },
  },
});

export const useConfirmDialogConfig = (stateMatch) => {
  const { config: wizardConfig, state: wizardState } = useWizardService();
  const classes = useDefaultStyles(getStyles);
  const i18n = useContext(I18nContext);
  const wizardId = wizardConfig && wizardConfig.id;

  const config = useMemo(() => {
    const dialogConfig = {
      confirmType: '', title: null, content: null, subText: '', disableConfirmPopup: false, className: classes.confirmDialogContent,
    };

    if (stateMatch) {
      const { wizardData } = wizardState.context;
      const currentStepId = getCurrentStepId(wizardState);

      if (
        (wizardId=== 'perf-max-north-star-setting-wizard' && currentStepId === 'CAMPAIGNSETTING')
          || (wizardId=== 'display-plus-wizard' && currentStepId === 'CAMPAIGN_EDIT')
          || (wizardId === 'SearchCampaignEditWizard' && currentStepId === 'CAMPAIGN_EDIT_SETTINGS')
          || (wizardId === 'standard-shopping-wizard' && currentStepId === 'CAMPAIGN_SETTINGS')
      ) {
        if (wizardData.customConfirmMessages && wizardData.customConfirmMessages.length > 0) {
          wizardData.customConfirmMessages.forEach((messageType) => {
            const foundMessage = CONFIRM_MESSAGES[messageType];
            if (foundMessage) {
              dialogConfig.content = i18n.getString(foundMessage.content);
              dialogConfig.title = i18n.getString(foundMessage.title);
              dialogConfig.confirmType = messageType;
            }
          });
        } else {
          dialogConfig.disableConfirmPopup = true;
        }
      } else {
        dialogConfig.disableConfirmPopup = true;
      }
    }

    return dialogConfig;
  }, [classes.confirmDialogContent, i18n, stateMatch, wizardId, wizardState]);

  return config;
};

export const useConfirmDialogConfigWithLogger = (stateMatch) => {
  const config = useConfirmDialogConfig(stateMatch) || {};
  const activity = useContext(ActivityContext);
  const onLog = (action) => {
    if (activity && activity.trace) {
      activity.trace(`[ConfirmDialog] ${action} title ${config.confirmType}`);
    }
  };

  return {
    ...config, onOpenFn: () => onLog('onOpenFn'), onConfirmFn: () => onLog('onConfirmFn'), onCancelFn: () => onLog('onCancelFn'),
  };
};
